import { Component, OnInit, ViewChild, OnDestroy, inject, output } from '@angular/core';
import {
    CustomStore,
    BreezeDxStoreService,
    AuthService,
    GenesisUnitOfWork,
    MessageService,
    PartPurchaseRepository,
    AppInformationService,
    UtilityService,
} from 'app/core/core.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { EntityQuery } from 'breeze-client';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Router, ActivatedRoute } from '@angular/router';
import { confirm, alert } from 'devextreme/ui/dialog';
import _ from 'lodash';
import { Subscription } from 'rxjs';
import { PartPurchaseDialogComponent } from 'app/shared/part-purchase-dialog/part-purchase-dialog.component';
import { CustomerReview, Part, PartPurchase, WarrantyRegistration } from 'app/core/model/entity-model';
import { SharedModule } from 'app/shared/shared.module';
import { OrderHistoryComponent } from 'app/orders/order-history/order-history.component';

@Component({
    selector: 'app-warranty-registrations',
    templateUrl: './warranty-registrations.component.html',
    styleUrls: ['./warranty-registrations.component.scss'],
    standalone: false,
})
export class WarrantyRegistrationsComponent implements OnInit {
    appInfo = inject(AppInformationService);
    reviews: any;
    filter: any;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(private uow: GenesisUnitOfWork, public auth: AuthService, private modalService: BsModalService, private utility: UtilityService) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.reviews = (await this.uow.getWarrantyRegistrations('orderLineDetail.orderLine.order.dealer')) as WarrantyRegistration[];
        this.utility.registrationCount.set((await this.utility.getRegistrationCount()) as any);
    }

    async rowPrepare(e) {
        if (e.rowType !== 'data') return;
        const review = e.data;
        if (review.acknowledged) {
            e.rowElement.className = e.rowElement.className + ' acknowledged';
        }
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async acknowledgeRegistration() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData() as WarrantyRegistration[];
        if (selectedRows.length === 0) return;

        await this.appInfo.pleaseWaitShow();
        selectedRows.forEach((warrantyRegistration) => {
            warrantyRegistration.acknowledged = new Date();
            warrantyRegistration.acknowledgedBy = this.auth.currentUser.userName;
        });
        await this.uow.commit();
        await this.getData();
        this.dataGrid.instance.clearSelection();
        this.utility.registrationCount.set((await this.utility.getRegistrationCount()) as any);
        await this.appInfo.pleaseWaitHide();
    }

    async deleteRegistration(registration: WarrantyRegistration) {
        if (!registration) return;

        const result = await confirm(`Are you sure you want to delete the selected warranty registration?`, this.appInfo.settings.company);
        if (!result) return;

        await this.appInfo.pleaseWaitShow();
        registration.deleted = new Date();
        registration.deletedBy = this.auth.currentUser.userName;
        await this.uow.commit();
        await this.getData();
        this.dataGrid.instance.clearSelection();
        this.utility.registrationCount.set((await this.utility.getRegistrationCount()) as any);
        await this.appInfo.pleaseWaitHide();
    }

    async assignToDetail(registration: WarrantyRegistration) {
        if (!registration) return;
        const modalRef = this.modalService.show(OrderHistoryComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                showAsDialog: true,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success && result.orderLineDetailId) {
                this.appInfo.pleaseWaitShow();
                registration.orderLineDetailId = result.orderLineDetailId;
                await this.uow.commit();
                await this.getData();
                this.appInfo.pleaseWaitHide();
            }
            modalRef.hide();
        });
    }
}
